/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IntegrationEventPccPatientLeadsInnerInsurancesInnerPayor
 */
export interface IntegrationEventPccPatientLeadsInnerInsurancesInnerPayor {
    /**
     * 
     * @type {string}
     * @memberof IntegrationEventPccPatientLeadsInnerInsurancesInnerPayor
     */
    id?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof IntegrationEventPccPatientLeadsInnerInsurancesInnerPayor
     */
    allowed_types?: Array<string>;
}

/**
 * Check if a given object implements the IntegrationEventPccPatientLeadsInnerInsurancesInnerPayor interface.
 */
export function instanceOfIntegrationEventPccPatientLeadsInnerInsurancesInnerPayor(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IntegrationEventPccPatientLeadsInnerInsurancesInnerPayorFromJSON(json: any): IntegrationEventPccPatientLeadsInnerInsurancesInnerPayor {
    return IntegrationEventPccPatientLeadsInnerInsurancesInnerPayorFromJSONTyped(json, false);
}

export function IntegrationEventPccPatientLeadsInnerInsurancesInnerPayorFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationEventPccPatientLeadsInnerInsurancesInnerPayor {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'allowed_types': !exists(json, 'allowed_types') ? undefined : json['allowed_types'],
    };
}

export function IntegrationEventPccPatientLeadsInnerInsurancesInnerPayorToJSON(value?: IntegrationEventPccPatientLeadsInnerInsurancesInnerPayor | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'allowed_types': value.allowed_types,
    };
}

